import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getConsent } from './CookieBanner';

// L'ID GA4 est lu depuis la variable d'environnement REACT_APP_GA_ID.
// Format attendu : "G-XXXXXXXXXX". Si absent, GA4 n'est PAS chargé.
const GA_ID = process.env.REACT_APP_GA_ID;

let scriptInjected = false;

function injectGA() {
  if (scriptInjected || !GA_ID) return;
  scriptInjected = true;

  // 1) gtag.js script
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  // 2) init snippet
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());

  // Consent Mode v2 (RGPD)
  const consent = getConsent();
  const analyticsGranted = consent?.analytics === true;
  const adsGranted = consent?.advertising === true;

  window.gtag('consent', 'default', {
    'ad_storage': adsGranted ? 'granted' : 'denied',
    'ad_user_data': adsGranted ? 'granted' : 'denied',
    'ad_personalization': adsGranted ? 'granted' : 'denied',
    'analytics_storage': analyticsGranted ? 'granted' : 'denied',
    'wait_for_update': 500,
  });

  window.gtag('config', GA_ID, {
    anonymize_ip: true,
    send_page_view: false, // On envoie manuellement pour capter les changements de route SPA
  });
}

function updateConsent(detail) {
  if (!window.gtag) return;
  const analyticsGranted = detail?.analytics === true;
  const adsGranted = detail?.advertising === true;
  window.gtag('consent', 'update', {
    'ad_storage': adsGranted ? 'granted' : 'denied',
    'ad_user_data': adsGranted ? 'granted' : 'denied',
    'ad_personalization': adsGranted ? 'granted' : 'denied',
    'analytics_storage': analyticsGranted ? 'granted' : 'denied',
  });
}

function sendPageView(path) {
  if (!window.gtag || !GA_ID) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/**
 * Composant GoogleAnalytics : à monter une seule fois dans App.
 * - Injecte GA4 uniquement si REACT_APP_GA_ID est configuré
 * - Respecte le consentement RGPD (Consent Mode v2)
 * - Suit les changements de route (SPA)
 */
const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!GA_ID) return;
    injectGA();

    const onConsentUpdate = (e) => updateConsent(e.detail);
    window.addEventListener('bcool:consent-updated', onConsentUpdate);
    return () => window.removeEventListener('bcool:consent-updated', onConsentUpdate);
  }, []);

  // Envoi manuel du page_view à chaque changement de route
  useEffect(() => {
    if (!GA_ID) return;
    const t = setTimeout(() => {
      sendPageView(location.pathname + location.search);
    }, 250); // laisse le title se mettre à jour via Helmet
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
};

export default GoogleAnalytics;
